import { MenuItem, Select } from '@mui/material'
import { useField } from 'formik'
import useQuery from 'hooks/useQuery'
import React from 'react'
import { translate } from 'utils/propKeysTranslations'
import { FieldWithContent } from './FieldWithContent'

const ITEM_HEIGHT = 48

export const UserReferenceField = ({
  defaultTitle = 'Seleccionar',
  fieldName,
  // endpoint,
  data,
  ...props
}) => {
  const [_field, meta, { setValue }] = useField({ ...props, name: fieldName })
  // const { data } = useQuery({ defaultEndpoint: endpoint })
  const options = data?.map?.(({ id, firstName, lastName }) => ({
    title: `${firstName} ${lastName}`,
    value: id,
  }))
  const isInvalid = !!meta.touched && !!meta.error

  return (
    <FieldWithContent fieldName={fieldName}>
      <div>
        <Select
          value={options ? meta.value || '' : ''}
          onChange={(e) => {
            setValue(e.target.value, true)
          }}
          error={isInvalid}
          displayEmpty
          fullWidth
          MenuProps={{
            sx: {
              maxHeight: ~~(ITEM_HEIGHT * 6.3),
            },
          }}
        >
          <MenuItem value='' disabled>
            <em>{(fieldName && `Seleccionar ${translate(fieldName)}`) || defaultTitle}</em>
          </MenuItem>
          {options?.map((o) => (
            <MenuItem key={o.value} value={o.value}>
              {o.title}
            </MenuItem>
          ))}
        </Select>
      </div>
      {isInvalid && <div className='text-red-500 text-sm'>{meta.error}</div>}
    </FieldWithContent>
  )
}
